import { Jwt } from "../../types/Jwt"

const parseJwt = ( token:string ):Jwt => {

  const data:Jwt | any = token.split('.').map( ( line: string, index:number ) => {
    if( index > 1 ) return null
    const data:any = JSON.parse( atob( line ) )
    return data
  })

  return data
}


export default parseJwt
